import React from 'react'
import styled from 'styled-components/macro'
import { EroIcon } from 'src/pages/TrustContentManagement/trustPortalConfiguration.styles'

const TiBotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  bottom: 25px;
  right: 25px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(90deg, #bb83ff 0%, #4381fd 111.48%);
  &:hover {
    background: linear-gradient(90deg, #d3aeff 0%, #96b9ff 111.48%);
  }
`

export type CopilotBotProps = {
  icon?: React.ReactNode | JSX.Element
  onClick: () => void
}

export const CopilotBot = ({
  onClick,
  icon,
}: CopilotBotProps): JSX.Element | null => {
  return (
    <TiBotContainer onClick={onClick}>
      {icon || <EroIcon $width={36} $height={36} />}
    </TiBotContainer>
  )
}
